// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__FpNxR","visible":"tooltip_visible__IByPH"};